export default function authHeader() {
  let user = JSON.parse(localStorage.getItem("user"));
  let token = localStorage.getItem("token");
  // const expireationTime = JSON.parse(localStorage.getItem('token_expires_at'));
  // console.log(user.access_token)

  if (user && token) {
    // const isTokenExpired = new Date(expireationTime) < new Date();
    // if (isTokenExpired) {
    // window.location.href = "/login";
    // }else{
    return { Authorization: "Bearer " + token };

    // }
  } else {
    return {};
  }
}
